import styled from "@emotion/styled";
import { Button, type ButtonProps } from "@mui/material";

const shared = {
  fontFamily: "Roboto",
  fontWeight: "600",
  fontSize: "15px",
  borderRadius: "16px",
  borderWidth: "1px",
  paddingY: 2,
  paddingX: 4,
  boxShadow: "0px 5px 8px 0px hsla(0, 0%, 0%, 0.16)",
  border: "1px solid",
  borderImageSource:
    "linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.1) 100%)",
};

const ButtonRed = styled(Button)<ButtonProps>(({ theme }) => ({
  flex: 1,
  height: "80px",
  color: "var(--color-white-100)",
  backgroundColor: "var(--color-red-500)",
  "&:hover": {
    backgroundColor: "var(--color-red-500-hover)",
  },
  ...shared,
}));
const ButtonGreen = styled(Button)<ButtonProps>(({ theme }) => ({
  flex: 1,
  height: "80px",
  color: "var(--color-black-900)",
  backgroundColor: "var(--color-green-500)",
  "&:hover": {
    backgroundColor: "var(--color-green-500-hover)",
  },

  ...shared,
}));
const ButtonBlue = styled(Button)<ButtonProps>(({ theme }) => ({
  flex: 1,
  height: "80px",
  color: "var(--color-white-100)",
  backgroundColor: "var(--color-blue-500)",
  "&:hover": {
    backgroundColor: "var(--color-blue-500-hover)",
  },

  ...shared,
}));
const ButtonWhite = styled(Button)<ButtonProps>(({ theme }) => ({
  flex: 1,
  height: "80px",
  color: "var(--color-black-900)",
  backgroundColor: "var(--color-white-100)",
  "&:hover": {
    backgroundColor: "var(--color-white-100-hover)",
  },

  ...shared,
}));
const ButtonYellow = styled(Button)<ButtonProps>(({ theme }) => ({
  flex: 1,
  height: "80px",
  color: "var(--color-black-900)",
  backgroundColor: "var(--color-yellow-500)",
  "&:hover": {
    backgroundColor: "var(--color-yellow-500-hover)",
  },

  ...shared,
}));

const ButtonBlack = styled(Button)<ButtonProps>(({ theme: Theme }) => ({
  flex: 1,
  height: "80px",
  color: "var(--color-white-100)",
  border: "1px solid var(--color-white-100)",
  backgroundColor: "var(--color-brand-secondary-500)",
  borderRadius: "16px",
  "&:hover": {
    backgroundColor: "var(--color-brand-secondary-400)",
  },
  borderImageSource:
    "linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.1) 100%)",
  boxShadow: "0px 3px 6px 0px hsla(249, 87%, 28%, 0.14)",
}));

const buttons = {
  ButtonRed,
  ButtonBlue,
  ButtonGreen,
  ButtonWhite,
  ButtonYellow,
  ButtonBlack,
};

export default buttons;
